module.exports = __webpack_public_path__ + "img/рз_28.796689cb.png";